import { CREATE, LOAD, REMOVE, UPDATE } from 'model/fraudFSPOverride';
import { formatSuccessMessage, UPDATED, FSP_FRAUD_CONFIG_LABEL } from 'consts';
import { create, load, update, remove } from 'sdk/fraudFSPOverride';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';
import { loadFSPProfileAction } from './export';

const keyName = { key: '', name: FSP_FRAUD_CONFIG_LABEL };

export const updateFraudFSPOverride = () =>
  callAction({
    api: update,
    dataName: ORM,
    formatSuccessMessage: formatSuccessMessage(keyName, UPDATED, false),
    type: UPDATE,
  });

function* updateAndPopulateExport(action) {
  const updateAction = updateFraudFSPOverride();

  if (yield updateAction(action)) {
    yield loadFSPProfileAction(action);
  }
}

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    CREATE.ACTION,
    callAction({
      api: create,
      dataName: ORM,
      type: CREATE,
    })
  );

  yield takeEvery(UPDATE.ACTION, updateAndPopulateExport);

  yield takeEvery(
    REMOVE.ACTION,
    callAction({
      api: remove,
      dataName: ORM,
      type: REMOVE,
    })
  );
}
